import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router preserves scroll position across navigations, which lands users
 * mid-page when they open /privacy or /terms from the footer. This resets to the
 * top on every route change, and honours in-page hash targets when present.
 *
 * `behavior: 'instant'` is required because the global CSS sets
 * scroll-behavior: smooth, which would otherwise animate the jump.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
